import { memo } from "react";
import { Link, useLocation } from "react-router-dom";
import { Gavel, History, Store, Gem, User } from "lucide-react";
import { cn } from "@/lib/utils";
import { TierBadge } from "@/components/ui/tier-badge";

const navItems = [
  { href: "/", icon: Gavel, label: "Auktionen", match: (p: string) => p === "/" || p === "/auctions", tier: null },
  { href: "/auctions/history", icon: History, label: "Verlauf", match: (p: string) => p.startsWith("/auctions/history"), tier: null },
  { href: "/market", icon: Store, label: "Markt", match: (p: string) => p.startsWith("/market"), tier: "alpha" as const },
  { href: "/shards", icon: Gem, label: "Shards", match: (p: string) => p === "/shards", tier: "beta" as const },
  { href: "/dash", icon: User, label: "Profil", match: (p: string) => p.startsWith("/dash") || p.startsWith("/panel"), tier: null },
];

const MobileBottomNav = memo(() => {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-md border-t border-border/50 safe-area-inset-bottom">
      <div className="flex items-center justify-around px-2 py-1.5">
        {navItems.map((item) => {
          const active = item.match(location.pathname);
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-colors min-w-[56px]",
                active
                  ? "text-primary"
                  : "text-muted-foreground active:text-foreground"
              )}
            >
              <item.icon size={20} strokeWidth={active ? 2.5 : 2} />
              <span className={cn(
                "text-[10px] leading-tight",
                active ? "font-semibold" : "font-medium"
              )}>
                {item.label}
              </span>
              {item.tier && (
                <TierBadge tier={item.tier} size="xs" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
});

MobileBottomNav.displayName = "MobileBottomNav";

export default MobileBottomNav;
